import { Box } from '@chakra-ui/core';
import { AnimateSharedLayout } from 'framer-motion';
import React, { useRef } from 'react';
import { QuestionnaireTemplateStore } from '../../store/questionnaireTemplateModel';
import { useAutoScroll } from '../hooks/useAutoScroll';
import { DropZone } from './Dropzone';
import { SortableElement } from './SortableElement';

const CANVAS_STYLES = {
  minH: 0,
  scrollbarGutter: 'stable',
  scrollbarColor: 'rgba(0, 0, 0, 0.3) transparent',
  scrollbarWidth: 'thin',
  bg: 'rgba(243, 243, 243, 1)',
  position: 'relative' as const,
  overflowY: 'auto',
  height: 'calc(100vh - 136px)',
  padding: 8,
} as const;

const ElementList = React.memo<{ rootElementIds: string[] }>(function ElementList({ rootElementIds }) {
  return (
    <>
      {rootElementIds.map((id, index) => (
        <React.Fragment key={id}>
          <SortableElement id={id} parentId={null} branch={null} />
          <DropZone parentId={null} branch={null} index={index + 1} />
        </React.Fragment>
      ))}
    </>
  );
});

export const Canvas = React.memo(function Canvas() {
  const rootElementIds = QuestionnaireTemplateStore.useStoreState((state) => state.rootElementIds);
  const isDragging = QuestionnaireTemplateStore.useStoreState((state) => !!state.ui.dragSource);
  const hasElements = rootElementIds.length > 0;
  const canvasRef = useRef<HTMLDivElement>(null);

  useAutoScroll(canvasRef, isDragging, {});

  return (
    <AnimateSharedLayout>
      <Box ref={canvasRef} data-testid="canvas" sx={CANVAS_STYLES} spacing={0}>
        {hasElements ? (
          <>
            <DropZone parentId={null} branch={null} index={0} />
            <ElementList rootElementIds={rootElementIds} />
          </>
        ) : (
          <DropZone parentId={null} branch={null} index={0} isInitial />
        )}
      </Box>
    </AnimateSharedLayout>
  );
});
